<dialog
  class="voice2voice-dialog"
  [attr.role]="data.ariaRole === 'alertdialog' ? 'alertdialog' : null"
  [attr.aria-labelledby]="data.titleText ? titleId : null"
  [attr.aria-label]="data.titleText ? null : 'Smart Fix dialog'"
  [attr.aria-describedby]="data.descriptionText ? descriptionId : null"
  cdkTrapFocus
  [cdkTrapFocusAutoCapture]="true"
  open
>
  <button class="close-button" aria-label="Close" tabindex="0">
    <i class="fa-light fa-xmark close-icon" (click)="onClose()"></i>
  </button>

  <div class="dialog-copy">
    <i [class]="'fa-light fa-' + data.iconName" [class.error-icon]="!!data.isErrorDialog" aria-hidden="true"></i>
    <h4 [id]="titleId">{{ data.titleText }}</h4>
    <p [id]="descriptionId" class="body">{{ data.descriptionText }}</p>
    @if (countdownSecondsRemaining !== null) {
      <p class="countdown body">
        {{ countdownPrefix }} <strong>{{ countdownSecondsRemaining }}</strong>
        {{ countdownSecondsRemaining === 1 ? 'second' : 'seconds' }}
      </p>
    }
  </div>
  <div class="buttons">
    <app-button
      [dataLabel]="data.firstButton?.text ?? 'first-button'"
      [buttonOptions]="{
        variant: data.firstButton?.variant,
      }"
      (onClick)="onAction(data.firstButton)"
      >{{ data.firstButton?.text }}</app-button
    >
    @if (data.secondButton) {
      <app-button
        [dataLabel]="data.secondButton.text"
        [buttonOptions]="{
          variant: data.secondButton.variant,
        }"
        (onClick)="onAction(data.secondButton)"
        >{{ data.secondButton.text }}</app-button
      >
    }
  </div>
</dialog>
